module.exports = __webpack_public_path__ + "img/BRB.d7c0dfed.svg";